// extracted by mini-css-extract-plugin
export default {"container":"styles_container__n5iWQ","items":"styles_items__VNK41","item":"styles_item__bTafk","title":"styles_title__iECmL"};